import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { Link } from 'react-router-dom';
import style from './EmailField.module.scss';

const EmailField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();
		window.location.href = `mailto:${restaurantForFullInfo?.email}`;
	};

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="emailLabel" theme="neutralLight" size="xs" />
			<Link className={style.link} to="#" onClick={handleClick}>
				{restaurantForFullInfo?.email || ''}
			</Link>
		</div>
	);
};

export default EmailField;
